package co.maytes.standupbot.dashboard.features.setup

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.stores.rememberSetupCheckStore
import co.maytes.standupbot.dashboard.stores.rememberSetupStatusStore
import co.maytes.standupbot.dashboard.stores.rememberUiStore
import kotlinx.browser.window

@Composable
fun OAuthOutcomeHandler() {
    val ui = rememberUiStore()
    val auth = rememberAuthStore()
    val checkStore = rememberSetupCheckStore()
    val statusStore = rememberSetupStatusStore()
    var verifyAfterReturn by remember { mutableStateOf(false) }
    val workspaceId = auth.currentUser?.workspace?.id
    LaunchedEffect(verifyAfterReturn, workspaceId, auth.isAdmin) {
        if (!verifyAfterReturn || !auth.isAdmin || workspaceId.isNullOrBlank()) return@LaunchedEffect
        if (checkStore.run(workspaceId)) statusStore.refresh(workspaceId)
        verifyAfterReturn = false
    }
    LaunchedEffect(Unit) {
        val search = runCatching { window.location.search }.getOrDefault("")
        val notice = OAuthOutcomeNotices.fromSearch(search) ?: return@LaunchedEffect
        ui.showToast(notice.message, notice.kind)
        verifyAfterReturn = notice.verifiesConnection
        runCatching {
            window.history.replaceState(null, "", window.location.pathname + notice.cleanedSearch + window.location.hash)
        }
    }
}

@Composable
fun SetupStatusLoader(routeKey: String) {
    val store = rememberSetupStatusStore()
    val auth = rememberAuthStore()
    val workspaceId = auth.currentUser?.workspace?.id
    LaunchedEffect(workspaceId, routeKey) {
        if (!workspaceId.isNullOrBlank()) store.refresh(workspaceId)
    }
}
